import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import HorizontalSlider from "../common/components/HorizontalSlider";
import { relationships } from "../features/listenerProfile";
import VerticalCenter from "../common/components/VerticalCenter";
import Center from "../common/components/Center";
import Padding from "../common/components/Padding";

export default function Question2Relationships() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <Padding>
        <Center>
          <h1>{t("How would you describe your romantic relationships?")}</h1>
        </Center>
      </Padding>
      <VerticalCenter>
        <HorizontalSlider
          leftElement={<p>{t("One person for life")}</p>}
          values={[1, 2.33, 3.66, 5]}
          defaultValue={2.33}
          onChange={(value) => dispatch(relationships(value))}
          rightElement={<p>{t("Open to all")}</p>}
        />
      </VerticalCenter>
    </>
  );
}
